import { useState, useCallback, useRef } from 'react'
import { NFCWorkerData } from '../../types/Core/NFCMessage'


export const useNFCReader = () => {
	const [nfcMessage, setNfcMessage] = useState<NFCWorkerData | null>(null)
	const [error, setError] = useState<string | null>(null)
	const readerRef = useRef<any>(null)

	const startReading = useCallback(async () => {
		if (!('NDEFReader' in window)) {
			setError('Web NFC API is not supported in this browser.')
			return
		}

		try {
			readerRef.current = new (window as any).NDEFReader()
			await readerRef.current.scan()
			readerRef.current.onreading = (event: any) => {
				const decoder = new TextDecoder()
				const jsonString = decoder.decode(event.message.records[0].data)
				try {
					const data = JSON.parse(jsonString) as NFCWorkerData
					if (typeof data.cardId === 'number' && typeof data.token === 'string') {
						setNfcMessage(data)
					} else {
						setError('Invalid worker data format')
					}
				} catch (err) {
					setError('Failed to parse worker data')
				}
			}
			readerRef.current.onerror = (err: any) => {
				setError(`Error reading NFC: ${err.message}`)
			}
		} catch (err: any) {
			setError(`Error initializing NFC reader: ${err.message}`)
		}
	}, [])

	const stopReading = useCallback(() => {
		if (readerRef.current) {
			readerRef.current.onreading = null
			readerRef.current.onerror = null
			// Optionally abort the scan if possible
			if (readerRef.current._controller) {
				readerRef.current._controller.abort()
			}
		}
		setNfcMessage(null)
		setError(null)
		readerRef.current = null
	}, [])

	return { nfcMessage, error, startReading, stopReading, setNfcMessage }
}
